import { useReward } from "react-rewards"

export default function useConfetti() {
  // requires two IDs to be set on components somewhere in the page of leftConfetti and rightConfetti
  const { reward: leftConfetti } = useReward("leftConfetti", "confetti", {
    lifetime: 250,
    angle: 75,
    spread: 75,
    decay: 0.96,
    elementCount: 90,
    elementSize: 12,
    startVelocity: 35,
  })
  const { reward: rightConfetti } = useReward("rightConfetti", "confetti", {
    lifetime: 250,
    angle: 120,
    spread: 75,
    decay: 0.96,
    elementCount: 80,
    elementSize: 12,
    startVelocity: 37,
  })
  const { reward: shortLifeLeftConfetti } = useReward(
    "leftConfetti",
    "confetti",
    {
      lifetime: 90,
      angle: 60,
      spread: 60,
      decay: 0.96,
      elementCount: 50,
      elementSize: 9,
      startVelocity: 34,
    }
  )
  const { reward: shortLifeRightConfetti } = useReward(
    "rightConfetti",
    "confetti",
    {
      lifetime: 90,
      angle: 120,
      spread: 75,
      decay: 0.96,
      elementCount: 50,
      elementSize: 9,
      startVelocity: 32,
    }
  )
  const { reward: smallLeftConfetti } = useReward("leftConfetti", "confetti", {
    lifetime: 75,
    angle: 60,
    spread: 60,
    decay: 0.96,
    elementCount: 35,
    elementSize: 7,
    startVelocity: 28,
  })
  const { reward: smallRightConfetti } = useReward(
    "rightConfetti",
    "confetti",
    {
      lifetime: 75,
      angle: 120,
      spread: 75,
      decay: 0.96,
      elementCount: 35,
      elementSize: 7,
      startVelocity: 26,
    }
  )

  type ConfettiOptions = { small?: boolean }

  function fireConfetti(options?: ConfettiOptions) {
    // @ts-ignore
    const isReduced =
      window?.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true
    if (isReduced) return

    if (options?.small) {
      smallLeftConfetti()
      smallRightConfetti()
    } else {
      if (document?.getElementById("leftConfetti")?.childNodes?.length === 0) {
        leftConfetti()
        rightConfetti()
      } else {
        // don't overwhelm the DOM with too many elements so fire some smaller ones
        shortLifeLeftConfetti()
        shortLifeRightConfetti()
      }
    }
  }

  return { fireConfetti }
}
